import { useQuery } from 'react-query';

import { fromISOString } from 'utils/date';
import { download } from 'utils/download';

import {
  GeneratedReport,
  getDownloadUrl,
  getGeneratedReports
} from 'RestAPIs/reports/generated';
import dayjs from 'dayjs';

export const loadReport = (generatedReport: GeneratedReport) => {
  getDownloadUrl(generatedReport.fileId).then(({ data }) => {
    download(data, generatedReport.filename || 'report.xls');
  });
};

export const useGetGeneratedReport = () => {
  const { data, isFetching } = useQuery(['generated'], async () => {
    const { data } = await getGeneratedReports();
    const reports = data.map((report) => {
      const item: GeneratedReport = { ...report };
      Object.entries(report.parameters).forEach(([key, value]) => {
        if (typeof value === 'string') {
          item.parameters[key] = dayjs(value).isValid()
            ? dayjs(value).toDate()
            : value;
        } else {
          item.parameters[key] = value;
        }
      });
      return item as GeneratedReport;
    });
    reports.sort(
      (a, b) =>
        fromISOString(b.inserted).valueOf() -
        fromISOString(a.inserted).valueOf()
    );
    return reports as GeneratedReport[];
  });
  return { isFetching, data };
};
